import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AwsScanSettings,
  QueryScanArgs,
  Scan,
  ScanProviderConfig,
  ScanScope,
  Space,
} from "types/generated";

export type ScanDetails = Pick<Scan, "id" | "name" | "description" | "labels" | "workerPool"> & {
  space: Pick<Space, "id">;
  providerConfigs: Array<
    Pick<ScanProviderConfig, "type" | "version" | "integration"> & {
      config: Pick<AwsScanSettings, "region">;
    }
  >;
  scope: Array<Pick<ScanScope, "type">>;
};

export const GET_SCAN: TypedDocumentNode<{ scan: ScanDetails }, QueryScanArgs> = gql`
  query GetScan($id: ID!) {
    scan(id: $id) {
      id
      name
      description
      labels
      space {
        id
      }
      workerPool
      providerConfigs {
        type
        version
        integration
        config {
          ... on AWSScanSettings {
            region
          }
        }
      }
      scope {
        type
      }
    }
  }
`;
